export default __webpack_public_path__ + "static/media/book-closure-completed.66332c39.png";